import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of } from 'rxjs';
import { loadNextPage, loadNextPageFailure, loadNextPageSuccess } from '../actions/page.actions';

@Injectable()
export class PageEffects {
  constructor(private actions$: Actions) {}

  loadNextPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNextPage),
      map(
        ({ nextPage }) => loadNextPageSuccess({ pageToLoad: nextPage }),
        catchError((error) => of(loadNextPageFailure({ error }))),
      ),
    ),
  );
}
